import get from 'lodash.get';

const getLayouts = (curation) => get(curation, 'layouts', []);

export const curationContainsItemsBySource = (curation, source) => {
  // Check at least one item contains the given source
  const packageContainsItemsBySource = (pkg) => {
    const items = get(pkg, 'items', []);
    return items.some(
      (item) => get(item, 'item.source.organization.name') === source,
    );
  };

  // Check at least one package contains matching source
  const layoutContainsItemBySource = (layout) => {
    const packages = get(layout, 'packages', []);
    return packages.some(packageContainsItemsBySource);
  };

  return getLayouts(curation).some(layoutContainsItemBySource);
};

export const getPackagesByType = (curation, type) => {
  const found = [];
  getLayouts(curation)
    .forEach((layout) => {
      const packages = get(layout, 'packages', []);
      found.push(...packages.filter((pkg) => pkg.type === type));
    });
  return found;
};

